import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
//*MUI
import { Box, Modal } from "@mui/material";
//*files
import cssClasses from "./AddDropDownList.module.css";
import Close from "../../Components/Icons/Close";
import DeleteIcon from "@mui/icons-material/Delete";
//subComponent

import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import CustomInput from "../../Subcomponents/CustomInput";
import Dot from "../../Components/Icons/Dot";
import Button from "../../Subcomponents/Button";
import DropDown from "../../Subcomponents/DropDown";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";

//service

import { errorTost, successTost } from "../../Services/Toast";
import { dismissLoader, presentLoader } from "../../Services/loader";
import {
  addNationality,
  addNative,
  addBudget,
  addWorksIn,
  checkDuplicates,
  duplicatesInNationalities,
  duplicatesInNative,
  duplicatesInBudget,
  duplicatesInWorksIn,
  updateNationality,
  updateNative,
  updateBudget,
  updateWorksIn,
} from "../../Services/Settings";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelCard: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  labelValue: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
}));

export default function AddDropDownList({
  open,
  handleClose,
  returnRes,
  passData,
  type,
  title,
}) {
  const classes = useStyles();
  const [helperText, setHelperText] = useState([{ fieldName: "" }]);
  const [arrayData, setArrayData] = useState([{ fieldName: "" }]);
  useEffect(() => {
    console.log(passData);
    if (title === "Nationality" && type === "Edit") {
      setArrayData((pre) => {
        pre[0].fieldName = passData.nationality;
        return [...pre];
      });
    }
    if (title === "Works In" && type === "Edit") {
      setArrayData((pre) => {
        pre[0].fieldName = passData.profession;
        return [...pre];
      });
    }
    if (title === "Native" && type === "Edit") {
      setArrayData((pre) => {
        pre[0].fieldName = passData.native;
        return [...pre];
      });
    }
    if (title === "Budget" && type === "Edit") {
      setArrayData((pre) => {
        pre[0].fieldName = passData.budget;
        return [...pre];
      });
    }
  }, []);

  async function save() {
    // toCheckDuplicates
    if (title === "Nationality") {
      let { data, count } = await checkDuplicates(
        "Nationality",
        arrayData.map((el) => el.fieldName)
      );
      if (count === 0) {
        let flag = validationDataFields();
        if (flag.flag) {
          if (title === "Nationality") {
            if (type === "Add") {
              presentLoader();
              arrayData.forEach((el, index) => {
                addNationality(el.fieldName)
                  .then((resp) => {
                    if (index === arrayData.length - 1) {
                      dismissLoader();
                      console.log("added in db");
                      successTost("Nationality added successfully");
                      closeModal();
                      returnRes(title);
                    }
                  })
                  .catch((err) => {
                    dismissLoader();
                    console.log(err);
                  });
              });
            } else if (type === "Edit") {
              console.log(data);
              presentLoader();
              updateNationality(passData.nationalityId, arrayData[0].fieldName)
                .then((resp) => {
                  dismissLoader();
                  console.log(resp);
                  successTost("Nationality updated successfully");
                  closeModal();
                  returnRes(title);
                })
                .catch((err) => {
                  dismissLoader();
                  console.log(err);
                });
            }
          }
        }
      } else {
        console.log(data);
        let existingData = data.map((el) => el.nationality);
        arrayData.forEach((e, i) => {
          if (existingData.includes(e.fieldName)) {
            setHelperText((pre) => {
              pre[i].fieldName = "This field is already present";
              return [...pre];
            });
          }
        });
      }
    }
    if (title === "Works In") {
      let { data, count } = await checkDuplicates(
        "Works In",
        arrayData.map((el) => el.fieldName)
      );
      if (count === 0) {
        let flag = validationDataFields();
        if (flag.flag) {
          if (title === "Works In") {
            if (type === "Add") {
              presentLoader();
              arrayData.forEach((el, index) => {
                addWorksIn(el.fieldName)
                  .then((resp) => {
                    if (index === arrayData.length - 1) {
                      dismissLoader();
                      console.log(resp);
                      console.log("added in db");
                      closeModal();
                      returnRes(title);
                      successTost("Profession added successfully");
                    }
                  })
                  .catch((err) => {
                    dismissLoader();
                    console.log(err);
                  });
              });
            } else if (type === "Edit") {
              presentLoader();
              updateWorksIn(passData?.professionId, arrayData[0].fieldName)
                .then((resp) => {
                  dismissLoader();
                  console.log(resp);
                  successTost("Profession updated successfully");
                  closeModal();
                  returnRes(title);
                })
                .catch((err) => {
                  dismissLoader();
                  console.log(err);
                });
            }
          }
        }
      } else {
        console.log(data);
        let existingData = data.map((el) => el.profession);
        arrayData.forEach((e, i) => {
          if (existingData.includes(e.fieldName)) {
            setHelperText((pre) => {
              pre[i].fieldName = "This field is already present";
              return [...pre];
            });
          }
        });
      }
    }
    if (title === "Native") {
      let { data, count } = await checkDuplicates("Native", arrayData.map((el) => el.fieldName));
      if (count === 0) {
        let flag = validationDataFields();
        if (flag.flag) {
          if (title === "Native") {
            if (type === "Add") {
              presentLoader();
              arrayData.forEach((el, index) => {
                addNative(el.fieldName)
                  .then((resp) => {
                    console.log(index, arrayData.length);
                    if (index === arrayData.length - 1) {
                      dismissLoader();
                      console.log(resp);
                      console.log("added in db");
                      closeModal();
                      returnRes(title);
                      successTost("Native added successfully");
                    }
                  })
                  .catch((err) => {
                    dismissLoader();
                    console.log(err);
                  });
              });
            } else if (type === "Edit") {
              presentLoader();
              updateNative(passData?.nativeId, arrayData[0].fieldName)
                .then((resp) => {
                  dismissLoader();
                  console.log(resp);
                  successTost("Native updated successfully");
                  closeModal();
                  returnRes(title);
                })
                .catch((err) => {
                  dismissLoader();
                  console.log(err);
                });
            }
          }
        }
      } else {
        let existingData = data.map((el) => el.native);
        arrayData.forEach((e, i) => {
          if (existingData.includes(e.fieldName)) {
            setHelperText((pre) => {
              pre[i].fieldName = "This field is already present";
              return [...pre];
            });
          }
        });
      }
    }
    if (title === "Budget") {
      let { data, count } = await checkDuplicates("Budget", arrayData.map((el) => el.fieldName));
      if (count === 0) {
        let flag = validationDataFields();
        if (flag.flag) {
          if (title === "Budget") {
            if (type === "Add") {
              presentLoader();
              arrayData.forEach((el, index) => {
                addBudget(el.fieldName)
                  .then((resp) => {
                    if (index === arrayData.length - 1) {
                      dismissLoader();
                      closeModal();
                      returnRes(title);
                      successTost("Budget added successfully");
                    }
                  })
                  .catch((err) => {
                    dismissLoader();
                    console.log(err);
                  });
              });
            } else if (type === "Edit") {
              presentLoader();
              updateBudget(passData?.budgetId, arrayData[0].fieldName)
                .then((resp) => {
                  dismissLoader();
                  successTost("Budget updated successfully");
                  closeModal();
                  returnRes(title);
                })
                .catch((err) => {
                  dismissLoader();
                  console.log(err);
                });
            }
          }
        }
      } else {
        let existingData = data.map((el) => el.budget);
        arrayData.forEach((e, i) => {
          if (existingData.includes(e.fieldName)) {
            setHelperText((pre) => {
              pre[i].fieldName = "This field is already present";
              return [...pre];
            });
          }
        });
      }
    }
  }

  async function addMoreFields() {
    let value = false;
    if (title === "Nationality") {
    let { data, count } = await checkDuplicates("Nationality",arrayData.map((el) => el.fieldName));
    if (count === 0) {
      value = arrayData.every((el, indexes) => {
        console.log(el.fieldName);
        if (el.fieldName !== "") {
          return true;
        } else {
          validationDataFields();
          return false;
        }
      });

      if (value === true) {
        let tempArray = arrayData;
        let tempHelperText = helperText;
        tempArray.push({
          fieldName: "",
        });
        helperText.push({
          fieldName: "",
        });
        setArrayData([...tempArray]);
        setHelperText([...tempHelperText]);
      }
    } else {
      console.log(data);
      let existingData = data.map((el) => el.nationality);
      arrayData.forEach((e, i) => {
        if (existingData.includes(e.fieldName)) {
          setHelperText((pre) => {
            pre[i].fieldName = "This field is already present";
            return [...pre];
          });
        }
      });
    }}
    if (title === "Works In") {
      let { data, count } = await checkDuplicates("Works In",arrayData.map((el) => el.fieldName));
      if (count === 0) {
        value = arrayData.every((el, indexes) => {
          console.log(el.fieldName);
          if (el.fieldName !== "") {
            return true;
          } else {
            validationDataFields();
            return false;
          }
        });
  
        if (value === true) {
          let tempArray = arrayData;
          let tempHelperText = helperText;
          tempArray.push({
            fieldName: "",
          });
          helperText.push({
            fieldName: "",
          });
          setArrayData([...tempArray]);
          setHelperText([...tempHelperText]);
        }
      } else {
        console.log(data);
        let existingData = data.map((el) => el.profession);
        arrayData.forEach((e, i) => {
          if (existingData.includes(e.fieldName)) {
            setHelperText((pre) => {
              pre[i].fieldName = "This field is already present";
              return [...pre];
            });
          }
        });
      }
    }
    if (title === "Native") {
      let { data, count } = await checkDuplicates("Native",arrayData.map((el) => el.fieldName));
      if (count === 0) {
        value = arrayData.every((el, indexes) => {
          console.log(el.fieldName);
          if (el.fieldName !== "") {
            return true;
          } else {
            validationDataFields();
            return false;
          }
        });
  
        if (value === true) {
          let tempArray = arrayData;
          let tempHelperText = helperText;
          tempArray.push({
            fieldName: "",
          });
          helperText.push({
            fieldName: "",
          });
          setArrayData([...tempArray]);
          setHelperText([...tempHelperText]);
        }
      } else {
        console.log(data);
        let existingData = data.map((el) => el.native);
        arrayData.forEach((e, i) => {
          if (existingData.includes(e.fieldName)) {
            setHelperText((pre) => {
              pre[i].fieldName = "This field is already present";
              return [...pre];
            });
          }
        });
      }
    }
    if (title === "Budget") {
      let { data, count } = await checkDuplicates("Budget",arrayData.map((el) => el.fieldName));
      if (count === 0) {
        value = arrayData.every((el, indexes) => {
          if (el.fieldName !== "") {
            return true;
          } else {
            validationDataFields();
            return false;
          }
        });

        if (value === true) {
          let tempArray = arrayData;
          let tempHelperText = helperText;
          tempArray.push({
            fieldName: "",
          });
          helperText.push({
            fieldName: "",
          });
          setArrayData([...tempArray]);
          setHelperText([...tempHelperText]);
        }
      } else {
        let existingData = data.map((el) => el.budget);
        arrayData.forEach((e, i) => {
          if (existingData.includes(e.fieldName)) {
            setHelperText((pre) => {
              pre[i].fieldName = "This field is already present";
              return [...pre];
            });
          }
        });
      }
    }
  }
  async function toCheckDuplicates(searchValue, index) {
    if (title === "Nationality") {
      return await duplicatesInNationalities(searchValue)
        .then((resp) => {
          console.log(resp);
          if (resp.data.length === 0) {
            return true;
          } else {
            setHelperText((pre) => {
              pre[index].fieldName = "This field is already present";
              return [...pre];
            });
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (title === "Works In") {
      return await duplicatesInWorksIn(searchValue)
        .then((resp) => {
          console.log(resp);
          if (resp.data.length === 0) {
            return true;
          } else {
            setHelperText((pre) => {
              pre[index].fieldName = "This field is already present";
              return [...pre];
            });
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (title === "Native") {
      return await duplicatesInNative(searchValue)
        .then((resp) => {
          console.log(resp);
          if (resp.data.length === 0) {
            return true;
          } else {
            setHelperText((pre) => {
              pre[index].fieldName = "This field is already present";
              return [...pre];
            });
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (title === "Budget") {
      return await duplicatesInBudget(searchValue)
        .then((resp) => {
          if (resp.data.length === 0) {
            return true;
          } else {
            setHelperText((pre) => {
              pre[index].fieldName = "This field is already present";
              return [...pre];
            });
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  function validationDataFields() {
    var form = true;
    arrayData.forEach((el, index) => {
      if (el.fieldName === "") {
        form = false;
        setHelperText((pre) => {
          pre[index].fieldName = "Please Enter Field name";
          return [...pre];
        });
      }
    });
    helperText.forEach((el, index) => {
      if (el.fieldName !== "") {
        form = false;
      }
    });
    let value = helperText.filter(({ fieldName }) => fieldName !== "");
    console.log({ value });
    if (value.length > 0) {
      form = false;
    }
    return {
      flag: form,
    };
  }

  function closeModal() {
    handleClose();
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperHeader}>
          <span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
          <div>{type} Dropdown Items</div>
        </div>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.selectedBlock}>
            <div className={cssClasses.blockLabel}>Selected Dropdown:</div>
            <div className={cssClasses.blocktitle}>{title}</div>
          </div>
          {arrayData.map((each, index) => {
            return (
              <div className={cssClasses.wrapperBlock}>
                <div className={cssClasses.blockLabel}>
                  Enter Field:<span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "50%" ,position:'relative'
}}>
                  <CustomInput
                    max={50}
                    value={each.fieldName}
                    handleChange={(newValue) => {
                      newValue = newValue.trimStart();
                      var alphabet = /^[A-Z*\sa-z]*$/;
                      var budgetPattern = /^[A-Za-z0-9\s\-.,()₹/&]*$/;
                      var pattern = title === "Budget" ? budgetPattern : alphabet;
                      if (newValue.match(pattern) || newValue === "") {
                        setArrayData((pre) => {
                          pre[index].fieldName = newValue;
                          return [...pre];
                        });
                        setHelperText((pre) => {
                          pre[index].fieldName = "";
                          return [...pre];
                        });
                      }
                    }}
                    placeholder="Enter Name"
                    inputType="label"
                    helperText={helperText[index]?.fieldName}
                  />
                    {index > 0 && (
                  <div
                    style={{
                      cursor: "pointer",
                      position:'absolute',
                      top: '2rem',right: '1rem'
                    }}
                    onClick={() => {
                      let arr = arrayData;
                      arr.splice(index, 1);
                      setArrayData([...arr]);

                      let tempHelperText = helperText;
                      tempHelperText.splice(index, 1);
                      setHelperText([...tempHelperText]);
                    }}
                  >
                    <Close width={"1.2rem"} height={"1.2rem"} />
                    {/* <DeleteIcon  style={{width:'2rem',height:'2rem'}}/> */}
                  </div>
                )}
                </div>
              
              </div>
            );
          })}
        </div>
        <div className={cssClasses.wrapperFooter}>
          {type === "Add" && (
            <div>
              <Button
                style={{
                  color: "#155EEF",
                  backgroundColor: "#ffffff",
                  border: "1px solid #155EEF",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={"Add More"}
                clicked={() => {
                  addMoreFields();
                }}
              />
            </div>
          )}

          <div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={type === "Add" ? "Save" : "Edit"}
              clicked={() => {
                save();
              }}
              //   disable={disabeNext}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
